module Omni.ResortMap {
    ngModule.directive('cycleSlideshow', (['$state', function ($state) {
        return {
            restrict: 'C',
            link: function (scope, element, attrs) {
                var slides = scope.slides;
                var html = null;
                var htmlClass;

                if ($state.current.name == 'gallery') {
                    htmlClass = "cycle-caption meeting";
                } else {
                    htmlClass = "cycle-caption";
                }

                html += "<div class='" + htmlClass + "'></div>";

                if (slides.length > 1) {
                    html += "<div class='cycle-prev'></div>";
                    html += "<div class='cycle-next'></div>";
                }

                angular.forEach(slides, function (slide: any, key) {
                    html += "<img src='" + slide.img_url + "' data-cycle-title='" + slide.caption + "' />";
                });
                element.html(html);

                element.cycle({
                    fx: "fade",
                    timeout: 5000,
                    captionTemplate: "{{cycleTitle}}",
                    log: false
                });

                element.on('$destroy', function () {
                    slides = [];
                });
            }
        };
    }]) as any);
}
